exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-checkradio[type=checkbox]:checked+label[data-v-20928c1e]:before,.is-checkradio[type=radio]:checked+label[data-v-20928c1e]:before{border:.15rem solid #dbdbdb}.is-checkradio[type=checkbox]+label[data-v-20928c1e]:after{border-width:.15rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20928c1e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/EditUser.vue
// module id = 485
// module chunks = 0